import React, { useEffect } from "react";
import "./HoppersCafeHomePage.scss"
import HoppersCafeHeroPage from "./HoppersCafeHeroPage";
import HoppersCadeAboutusPage from "./HopperCafeAboutusPage";
import HoppersCafeServicePage from "./HoppersCafeServicePage";
import HoppersCafeMenuPage from "./HoppersCafeMenuPage";
import HoppersCafeGalleryPage from "./HoppersCafeGalleryPage";
import HopperCafeReviewPage from "./HopperCafeReviewPage";
import HopperCafeSpecials from "./HopperCafeSpecials";
import HopperCafeSubscriptionPage from "./HopperCafeSubscriptionPage";
import { sortByOrderAscending } from "../../helper/helper";
import { useSelector } from "react-redux";

const HoppersCafeHomePage = () => {
    const pages = useSelector((state) => state.companyData.pages)
    const page = pages.find((page) => page.PageId === "homeCafe")
    const Components = page?.Components || []
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    const getComponents = (component) => {
        switch (component.ID) {
            case "HoppersCafeHeroPage":
                return <HoppersCafeHeroPage components={component.Components} heroBackground={component?.Props?.bgSrc} />

            case "HoppersCadeAboutusPage":
                return <HoppersCadeAboutusPage components={component.Components} />
            case "HoppersCafeServicePage":
                return <HoppersCafeServicePage components={component.Components} />
            case "HoppersCafeMenuPage":
                return <HoppersCafeMenuPage components={component.Components} />
            case "HoppersCafeGalleryPage":
                return <HoppersCafeGalleryPage components={component.Components} />
            case "HopperCafeReviewPage":
                return <HopperCafeReviewPage components={component.Components} />
            case "HopperCafeSpecials":
                return <HopperCafeSpecials components={component.Components} />
            case "HopperCafeSubscriptionPage":
                return <HopperCafeSubscriptionPage components={component.Components} background={component?.Props?.bgSrc} message={component?.Props?.successMessage} />
            default:
                return <div />
        }

    }
    return (
        <div className="HoppersCafeHomePage">
            {sortByOrderAscending(Components).map((component, key) => {
                return (<div key={key}>
                    {getComponents(component)}
                </div>)
            })}
        </div>
    )

}
export default HoppersCafeHomePage